import { api } from ".";

export const sendAnalytics = (data: AnalyticsEvent[]): Promise<ApiResponse<any>> => {
  return api.post("/analytics", data);
};
